define(function(require, exports, module) {
    'use strict';

    var BaseModel = require('common/base.model');
    var server = require('server');

    module.exports = BaseModel.extend({
        idAttribute: 'name',

        parse: function(response, options) {
            var tag = response.data.tags[0];
            if (tag) {
                tag.value = !options.isDel;
            }
            return tag;
        },

        fetch: function() {
            this.set('ready', false);

            return BaseModel.prototype.fetch.apply(this, arguments);
        },

        save: function() {
            this.set('ready', false);

            return BaseModel.prototype.save.apply(this, arguments);
        },

        sync: function(method, model, options) {
            if (!['read', 'update'].includes(method)) {
                return;
            }

            var request;

            switch (method) {
                case 'read': {
                    request = this._getPlayerTags();
                    break;
                }
                case 'update': {
                    request = options.isDel
                        ? this._removePlayerTag()
                        : this._savePlayerTag();
                    break;
                }
            }

            return request
                .done((msg) => {
                    if (msg.ID === 35545) {
                        require('bundle').dispatcher.dispatch('socket:push', msg);
                    }
                    return options.success;
                })
                .fail(options.error)
                .always(function() {
                    this.set('ready', true);
                }.bind(this));
        },

        _getPlayerTags: function() {
            return server.send({
                ID: 35547,
                tagName: this.get('name'),
                description: 'Get player tag',
                responses: [35548, 35549]
            });
        },

        _savePlayerTag: function() {
            return server.send({
                ID: 35544,
                responses: [35545, 35546],
                description: 'Set player tags',
                tags: [{ name: this.get('name') }]
            });
        },

        _removePlayerTag: function() {
            return server.send({
                ID: 35553,
                responses: [35554, 35555],
                description: 'Remove player tags',
                tags: [{ name: this.get('name') }]
            });
        }
    });
});
